export const CALENDAR = '/calendar/'
export const CALENDAR_EVENT = `${CALENDAR}event/`
export const CALENDAR_EVENT_STUDENT = `${CALENDAR_EVENT}student/`
export const CALENDAR_EVENT_ALL = `${CALENDAR}event/all`
